import { lightTheme } from "../components/Theme"


export default lightTheme;
